export function SignUpSuccessMessagePlain() {
  return (
    <div style={{ color: "green", marginBottom: 8 }}>
      Thank you for signing up! Please check your email and click the verification link to activate your account. You will not be able to log in until your email is verified.
    </div>
  );
}
